
var variantId = "";
var relatedProduct = "";
let collectionJson = [];
let relatedProductArray = [];
let cartArray;
// Ajax cart JS for Drawer and Cart Page
class quickShop extends HTMLElement {
  constructor() {
    super();

    this.closeBy = this.querySelector(".close-quickshop");
    this.bindEvents();
    this.updateEvents();

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );
  }

  /**
   * Escape Click event to close drawer when focused within Cart Drawer
   *
   * @param {event} Event instance
   */
  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;
    this.querySelector(".close-quickshop").dispatchEvent(new Event("click"));
  }

  /**
   * bind click and keyup event to Cart Icons
   * bind keyUp event to Cart drawer component
   * bind Other inside element events
   *
   */
  bindEvents() {
    this.openeBy = document.querySelectorAll(".quickshop--button");

    this.openeBy.forEach((btn) =>
      btn.addEventListener("click", this.openQuickShop.bind(this))
    );
    this.addEventListener("keyup", this.onKeyUp.bind(this));
  }

  updateEvents() {
    this.openeBy = document.querySelectorAll(".quickshop--button");
    if (this.openeBy)
      this.openeBy.forEach((btn) =>
        btn.addEventListener("click", this.openQuickShop.bind(this))
      );
  }

  async _loadQuickShop(handle, event) {
    $.ajax({
      url: `/products/${handle}.js`,
      type: "GET",
      data: [],
      dataType: "json",
      success: function (response) {
        // console.log("response", response , response.images[0] );

        let productURL = "product/" + response.handle;

        $("[data-more-details]").attr("href", response.url);
        if (response.selling_plan_groups.length == 0) {
          //             $("[data-widget-container]").style.display="none";
        }
        let discount = " ";
        response.tags.forEach(function (i, v) {
          if (i.startsWith("discount_")) {
           // console.log("iii==>", i);
            discount = i.replace("discount_", " ");
          }
        });
        discount = `${discount}%`;

       // console.log("data-label-discount", discount, response);

        variantId = response.variants[0].id;
        var productPrice = Shopify.formatMoney(
          response.price,
          window.globalVariables.money_format
        );
        $("[data-label-discount]").text(discount);
        $("[data-product-price]").text(productPrice);
       // console.log("response.variants[0].id", response.variants[0].id);
        $("[data-variantId]").attr("data-variantId", response.variants[0].id);
        $("[data-variantId]").attr("data-producthandle", response.handle);
        $("[data-selling-plan]").attr(
          "data-selling-plan",
          response.selling_plan_groups[0].selling_plans[0].id
        );
        $("[data-frequency]").text(
          response.selling_plan_groups[0].selling_plans[0].name
        );
        document.querySelector("[data-product-title]").innerHTML =
          response.title;
        $("[data-img]").prop("src", response.images[0]);

        let varianthtml = ``;

        if (response.variants.length > 1) {
          for (const [i, variant] of response.variants.entries()) {
            let varaintData = JSON.stringify(variant);
            let html = `<div onclick='_getvariantDetails(${varaintData})' class="product-swatch__item" data-index="option1" data-value="1 month" js-product-swatch="option" data-available="true">
                <input id="option${i}-0" ${
              i ? 1 : "checked"
            } class="swatch__input invisible" name="option0_swatch"  tabindex="-1" type="radio"  value="${
              variant.option1
            }" data-index="option${i}" js-product-form="optionSelector">
                <label class="swatch__label" for="option${i}-0" tabindex="0" data-index="option${i}" data-value="${
              variant.option1
            }" js-product-swatch="label">
                  <div class="swatch__button" js-product-swatches="label">
                    <span>${variant.option1}</span>
                  </div>
                </label>
              </div>`;
            varianthtml = varianthtml + html;
          }
          $("[data-swatches]").html(varianthtml);
        }
      },
      error: function (error) {},
    });
  }

  /**
   * Open QuickShop modal and add focus to modal container
   *
   * @param {event} Event instance
   */
  openQuickShop(event) {
    event.preventDefault();
    const _this = event.currentTarget;
    const handle = _this.dataset.handle;
    relatedProduct = $(_this).data("related-product");
    if (!handle) return;

    this._loadQuickShop(handle, event).then((quickShopData) => {
      document.querySelector(".popup").style.display = "block";
      $("[data-popup]").css("display", "block");
    });
  }

  /**
   * Open QuickShop and Remove focus from modal container
   *
   * @param {event} Event instance
   */
}
setTimeout(() => {
  customElements.define("quick-shop", quickShop);
}, 1500);

function _getvariantDetails(variant) {
  variantId = variant.id;
  var productPrice = Shopify.formatMoney(
    variant.price,
    window.globalVariables.money_format
  );
  $("[data-product-price]").text(productPrice);
  $("[data-selling-plan]").css("pointer-events", "all");
}

function _quantityChange(data) {
  var quantityValue;
  if (data == "plus") {
    quantityValue = $("[data-quantity]").val();
    quantityValue = parseInt(quantityValue);
    quantityValue = quantityValue + 1;
    $("[data-quantity]").val(quantityValue);
  } else {
    quantityValue = $("[data-quantity]").val();
    quantityValue = quantityValue - 1;
    if (quantityValue != 0) {
      $("[data-quantity]").val(quantityValue);
    }
  }
}

function openQuickShops(event) {
  event.preventDefault();
  const _this = event.currentTarget;
  const handle = _this.dataset.handle;
  relatedProduct = $(_this).data("related-product");
  if (!handle) return;

  _loadQuickShops(handle, event);
}

function _loadQuickShops(handle, event) {
  $.ajax({
    url: `/products/${handle}.js`,
    type: "GET",
    data: [],
    dataType: "json",
    success: function (response) {
     // console.log("response==", response);
      document.querySelector(".popup").style.display = "block";
      $("[data-popup]").css("display", "block");
      let productURL = "product/" + response.handle;
      $("[data-more-details]").attr("href", response.url);
      if (response.selling_plan_groups.length == 0) {
        $("[data-widget-container]").style.display = "none";
      }

      let discount = "";
      response.tags.forEach(function (i, v) {
        if (i.startsWith("discount_")) {
         // console.log("iii==>", i);
          discount = i.replace("discount_", " ");
        //  console.log("discountdiscountdiscount", discount);
        }
      });
      discount = `${discount}%`;
      // console.log("discount===>", discount);

      $("[data-label-discount]").text(discount);
      variantId = response.variants[0].id;
      var productPrice = Shopify.formatMoney(
        response.price,
        window.globalVariables.money_format
      );
      $("[data-product-price]").text(productPrice);
      //console.log("response.variants[0].id", response.variants[0].id);
      $("[data-variantId]").attr("data-variantId", response.variants[0].id);
      $("[data-variantId]").attr("data-producthandle", response.handle);
      //  console.log("productPrice",productPrice);
      $("[data-selling-plan]").attr(
        "data-selling-plan",
        response.selling_plan_groups[0].selling_plans[0].id
      );
      $("[data-frequency]").text(
        response.selling_plan_groups[0].selling_plans[0].name
      );
      document.querySelector("[data-product-title]").innerHTML = response.title;
      $("[data-img]").prop("src", response.images[0]);
      let varianthtml = ``;

      if (response.variants.length > 1) {
        for (const [i, variant] of response.variants.entries()) {
          let varaintData = JSON.stringify(variant);
          let html = `<div onclick='_getvariantDetails(${varaintData})' class="product-swatch__item" data-index="option1" data-value="1 month" js-product-swatch="option" data-available="true">
                <input id="option${i}-0" ${
            i ? 1 : "checked"
          } class="swatch__input invisible" name="option0_swatch"  tabindex="-1" type="radio"  value="${
            variant.option1
          }" data-index="option${i}" js-product-form="optionSelector">
                <label class="swatch__label" for="option${i}-0" tabindex="0" data-index="option${i}" data-value="${
            variant.option1
          }" js-product-swatch="label">
                  <div class="swatch__button" js-product-swatches="label">
                    <span>${variant.option1}</span>
                  </div>
                </label>
              </div>`;
          varianthtml = varianthtml + html;
        }
        $("[data-swatches]").html(varianthtml);
      }
    },
    error: function (error) {},
  });
}

/* Oct 2026 FIX: after adding to cart from a collection card or the quick-shop popup, open the
   native cart drawer (snippets/native-cart-drawer.liquid). The old code rebuilt the drawer with
   legacy markup and then clicked "[data_cart-icon]" -- a typo that matches nothing -- so the
   drawer never opened (it only worked while Rebuy's cart was handling it). Now: re-render the
   native drawer, then open it with the theme's own toggle-cart control (only if it's closed). */
function hfOpenNativeCart() {
  if (window.location.pathname === "/cart") {
    location.reload();
    return;
  }
  function open() {
    var drawer = document.querySelector(".js-ajax-cart");
    if (drawer && !drawer.classList.contains("is-closed")) return;
    var toggle = document.querySelector('[data-behavior="toggle-cart"]');
    if (toggle) {
      toggle.click();
    } else {
      window.location.href = "/cart";
    }
  }
  if (window.HFCartDrawer && typeof window.HFCartDrawer.render === "function") {
    window.HFCartDrawer.render().then(open).catch(open);
  } else {
    open();
  }
}

function _submitNormalProduct() {
  // console.log("method call");
  event.preventDefault();
  event.stopPropagation();
  relatedProduct = "";
  const _this = event.currentTarget;

  // let quantity = $("[data-quantity]").val();

  let quantity = $("[data-quantity]").val();
  variantId = $(_this).attr("data-variant_id");
  //  console.log("variantId==>",variantId,_this);

  relatedProduct = $(_this).data("related-product");
  //  variantId= $(_this).data("variantid");
  quantity = quantity && quantity !== undefined ? quantity : 1;
  let rechargeCartItems = {
    id: variantId,
    quantity: `${quantity}`,
  };
  if (relatedProduct && relatedProduct != '') {
    rechargeCartItems = {
      id: variantId,
      quantity: `${quantity}`,
      properties: {
        _related_collection: relatedProduct,
      },
    };
  }

  //console.log("rechargeCartItems",rechargeCartItems);

  $.ajax({
    url: "/cart/add.js",
    type: "POST",
    data: { items: [rechargeCartItems] },
    dataType: "json",
    success: function (response) {
      var popup = document.querySelector(".popup");
      if (popup) popup.style.display = "none";
      $("[data-popup]").css("display", "none");
      hfOpenNativeCart();
    },
    error: function (error) {},
  });
}

function _submitRechargeProduct() {
  const _this = event.currentTarget;
  let quantity = $("[data-quantity]").val();
  variantId = $(_this).attr("data-variantid");
  //  quantity = quantity && quantity !== undefined ? quantity : 1;
  if (!relatedProduct || relatedProduct == "") {
    relatedProduct = $(_this).data("related-product");
    variantId = $(_this).attr("data-variantid");
    quantity = quantity && quantity !== undefined ? quantity : 1;
  }
  // console.log("variantId",variantId,"quantity",quantity);

  let rechargeCartItems = {
    id: variantId,
    quantity: `${quantity}`,
  };
  if (relatedProduct && relatedProduct != '') {
    rechargeCartItems = {
      id: variantId,
      quantity: `${quantity}`,
      properties: {
        _related_collection: relatedProduct,
      },
    };
  }
  // console.log("relatedProduct==>",relatedProduct,$(_this).attr('data-selling-plan'));

  if ($("#myPopup [data-radio-onetime]").prop("checked") == false) {
    // rechargeCartItems['selling_plan'] = $("[data-selling-plan]").attr('data-selling-plan');
    rechargeCartItems["selling_plan"] = $(_this).attr("data-selling-plan");
  }
  //console.log(rechargeCartItems);

  $.ajax({
    url: "/cart/add.js",
    type: "POST",
    data: { items: [rechargeCartItems] },
    dataType: "json",
    success: function (response) {
      var popup = document.querySelector(".popup");
      if (popup) popup.style.display = "none";
      $("[data-popup]").css("display", "none");
      $("[data-img]").prop("src", "https://via.placeholder.com/500/ffffff/eeeeee?text=Loading...");
      hfOpenNativeCart();
    },
    error: function (error) {},
  });

}

function closeQuickShop() {
  document.querySelector(".popup").style.display = "none";
  $("[data-popup]").css("display", "none");
  $("[data-img]").prop("src", "https://via.placeholder.com/500/ffffff/eeeeee?text=Loading...");
}

Shopify.formatMoney = function (cents, format) {
  if (format == null || format == undefined) {
    format = window.globalVariables.money_format || "${{amount}}";
  }
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;
  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";
    return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }
  return formatString.replace(placeholderRegex, value);
};
const cartItemSelling = (properties) => {
  let propertiesHtml = '<ul class="list-reset">';

  // separately, if contains Recharge properties, add custom key/value line
  if (properties.hasOwnProperty("selling_plan")) {
    propertiesHtml += `<li class="font-size-1 text-grey">${properties.selling_plan.name}</li>`;
  }

  propertiesHtml += "</ul>";

  return propertiesHtml;
};
function cartItemHtml(response) {
  //console.log("response==>",response);
  if (window.location.pathname === "/cart") {
    location.reload();
    // Frame.EventBus.emit('AjaxCart:updated', json);
  }

  let cart = response;
  $("[data-cart-count]").text(cart.item_count);
  $("[data-cartitem-count]").text(cart.item_count);
  $("[data-count]").text(cart.item_count);
  if ($("[data-count]").hasClass("hide")) {
    $("[data-count]").removeClass("hide");
  }
  let upsellHTML = "";

  let cartTotal = Shopify.formatMoney(
    cart.original_total_price,
    window.globalVariables.money_format
  );

  $("[data-origional-price]").text(cartTotal);
  let line_item_html = "";
  let variantTitle = "";
  relatedProductArray = [];
  for (const [i, item] of cart.items.entries()) {
    if (item.variant_title != null) {
      variantTitle = item.variant_title;
    } else {
      variantTitle = "";
    }
    var productPrice = Shopify.formatMoney(
      item.line_price,
      window.globalVariables.money_format
    );
    var discountPrice;
    let priceELement;
    var totalDiscount;
    let TotalDiscountElement;
    let Selling_prop = null;

    if (item.selling_plan_allocation) {
      var discountLinePrice =
        item.selling_plan_allocation.per_delivery_price * item.quantity;
      var withoutDiscountPrice =
        item.selling_plan_allocation.compare_at_price * item.quantity;
      totalDiscount = withoutDiscountPrice - discountLinePrice;
      discountPrice = Shopify.formatMoney(
        discountLinePrice,
        window.globalVariables.money_format
      );
      withoutDiscountPrice = Shopify.formatMoney(
        withoutDiscountPrice,
        window.globalVariables.money_format
      );

      totalDiscount = Shopify.formatMoney(
        totalDiscount,
        window.globalVariables.money_format
      );

      TotalDiscountElement = `<span class="totalDiscount">(-${totalDiscount})</span>`;

      priceELement = `<div class="font-size-2 font-weight-5 letter-spacing-1 text-right">
                            <s>${withoutDiscountPrice}</s>
                            <span class="block font-weight-5">${discountPrice}</span>
                            </div>`;
      Selling_prop = cartItemSelling(item.selling_plan_allocation);
    } else {
      TotalDiscountElement = ` `;
      priceELement = `<div class="font-size-2 font-weight-5 letter-spacing-1 text-right">
                            <span class="block font-weight-5">${productPrice}</span>
                            </div>`;
    }

    let html = `
            <div class="ajax-cart-item relative flex padding-4 border-bottom border-light-grey" data-cart-line="1">
              <a href="${
                item.url
              }" class="block margin-right-3 js-cart-tabindex">
                <img src="${
                  item.image
                }" class="cart-item-image fit-cover block width-100">
              </a>
              <div class="flex-item-1">
                <div class="flex justify-between items-start">
                  <div>
                    <a href="${
                      item.url
                    }" class="ajax-cart-item-title block link font-size-1 font-weight-6 letter-spacing-2 js-cart-tabindex">${
      item.title
    }</a>
                    <p class="margin-vertical-1 font-size-1 font-weight-5 text-dark-grey">${variantTitle}  </p>
                    <ul class="list-reset"></ul>
                    ${Selling_prop == null ? `` : Selling_prop}
					<div>${TotalDiscountElement}</div>
                  </div>

                  <button class="ajax-cart-item-remove-button button-reset js-cart-tabindex" data-behavior="remove-line">
                    <svg class="svg-close" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <title>Close</title>
              <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="currentColor"></path>
            </svg>
                  </button>
                </div>
                <div class="flex justify-between items-center margin-top-4">
                  <div class="js-number-input number-input">
                      <button type="button" data-behavior="decrement" class="js-cart-tabindex"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
              <title>minus</title>
              <path d="M436 284c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12H12c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h424z" fill="currentColor"></path>
            </svg></button>
                      <label for="cart_quantity_1" class="invisible">Product Quantity</label>
                      <input type="number" id="cart_quantity_${
                        i + 1
                      }" name="cart_quantity_${i + 1}" value="${
      item.quantity
    }" min="1" max="999" data-behavior="update-line" class="js-cart-tabindex">
                      <button type="button" data-behavior="increment" class="js-cart-tabindex"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
              <title>plus</title>
              <path d="M436 228H252V44c0-6.6-5.4-12-12-12h-32c-6.6 0-12 5.4-12 12v184H12c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h184v184c0 6.6 5.4 12 12 12h32c6.6 0 12-5.4 12-12V284h184c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12z" fill="currentColor"></path>
            </svg></button>
                    </div>
                   ${priceELement}


                </div>
              </div>
            </div>`;
    line_item_html = line_item_html + html;
    // console.log("item",item);
    if (item.properties != null) {
      relatedProductArray.push(item.properties._related_collection);
    }
  }

  addUpsellProduct();

  if (!$("[data-empty_cart_msg]").hasClass("hide")) {
    $("[data-empty_cart_msg]").addClass("hide");
  }
  if ($("[data-empty_cart]").hasClass("hide")) {
    $("[data-empty_cart]").removeClass("hide");
  }
  if ($("[data-show-cart-total]").hasClass("hide")) {
    $("[data-show-cart-total]").removeClass("hide");
  }

  $("[data-cart_line_item]").html(line_item_html);
}

$("[data-collection-json]").each(function (i, v) {
  collectionJson.push(JSON.parse($(this).html()));
});

$("#myPopup [data-template-legacy-radio]").click(function () {
  if ($("#myPopup [data-radio-onetime]").prop("checked")) {
    $("#myPopup [data-plans-container]").css("display", "none");
  } else {
    $("#myPopup [data-plans-container]").css("display", "block");
  }
});

function addUpsellProduct() {
  let upsellHTMLProduct = "";
  let addedProduct = 0;
  const drawer = document.querySelector('.js-ajax-cart');
  const upsellItemsWrapper = drawer.querySelector('.upsell-products');
  const defaultCollection = upsellItemsWrapper.dataset.collection;
  relatedProductArray.push(defaultCollection);
  collectionJson.forEach(function (i, v) {
    if (relatedProductArray.includes(i.collection.handle)) {
      addedProduct = addedProduct + 1;
      if (relatedProductArray.length > 0) {
        var valueIndex = relatedProductArray.indexOf(i.collection.handle);
        if (valueIndex !== -1) {
          relatedProductArray.splice(valueIndex, 1);
        }

        collectionJson[v].collection_product.slice(0, 4).forEach(function (x, y) {
          const productPrice = Shopify.formatMoney(
            x.price,
            window.globalVariables.money_format
          );
          let tempUpsellHTML = `
<div class="upsell-product flex items-center grid-gap-3" data-product-title="${x.title}" data-product-id="${x.id}">
<div class="upsell-product__image">
<div class="image image--30378617897126 image--responsive " style="padding-top: 100.0%">
<img class="image__img lazyautosizes lazyloaded" src="${x.featured_image}">
</div>
</div>

<div class="upsell-product__content">
<a href="/products/${x.handle}" class="font-size-1 font-weight-5 link">
<!-- unwidow -->${x.title}

</a>
<div class="upsell-product__reviews">
<div data-oke-reviews-product-listing-rating=""></div>
</div>
<div class="font-size-1 text-dark-grey margin-top-1">
${productPrice}
</div>
</div>
<div class="upsell-product__form">
<button data-behavior="ajax-cart-button" data-producthandle="${x.handle}" data-variant-id="${x.variants[0].id}" data-related-collection="" class="ghost-button js-prd-atc font-size-1 button button-primary button-small">
Add +
</button>
</div>
</div>
`;
          upsellHTMLProduct = tempUpsellHTML + upsellHTMLProduct;
        });
      } else {
      }
    }
  });
  //   console.log("upsellHTMLProduct",upsellHTMLProduct);

  $("[data-collection]").html("");
  $("[data-collection]").html(upsellHTMLProduct);
  removeduplicateProduct();
}
let uniqueUpsellProduct = [];
let removeDuplicateProduct = [];
let uniqUpsellProducttitle = [];
let removDuplicartUPsellProduct = [];
function removeduplicateProduct() {
  document.querySelectorAll("[data-product-id]").forEach(function (i, v) {
    removeDuplicateProduct.push(i.getAttribute("data-product-id"));
  });
  // console.log("removeDuplicateProduct==>",removeDuplicateProduct);
  $.each(removeDuplicateProduct, function (i, el) {
    if ($.inArray(el, uniqueUpsellProduct) === -1) uniqueUpsellProduct.push(el);
  });
  //console.log("uniqueUpsellProduct==>",uniqueUpsellProduct);

  document.querySelectorAll("[data-product-id]").forEach(function (i, v) {
    if (uniqueUpsellProduct.includes(i.getAttribute("data-product-id"))) {
      var valueIndex = uniqueUpsellProduct.indexOf(
        i.getAttribute("data-product-id")
      );
      if (valueIndex !== -1) {
        uniqueUpsellProduct.splice(valueIndex, 1);
      }
    } else {
      //i.remove();
    }
  });
  removDuplicartUPsellProduct = [];
  removeCartProductFromUpsell();
}

function removeCartProductFromUpsell() {
  //   document.querySelectorAll("[data-product-title]").forEach(function(i,v){
  //     removDuplicartUPsellProduct.push( i.getAttribute("data-product-title"))
  //     console.log(i);
  //     i.style.display ="none";
  //     console.log(i);
  //   });
  cartArray.forEach(function (i, v) {
    removDuplicartUPsellProduct.push(i.title);
  });

  // console.log("removDuplicartUPsellProduct",removDuplicartUPsellProduct);

  document.querySelectorAll("[data-product-title]").forEach(function (i, v) {
    if (
      removDuplicartUPsellProduct.includes(i.getAttribute("data-product-title"))
    ) {
      var valueIndex = removDuplicartUPsellProduct.indexOf(
        i.getAttribute("data-product-title")
      );
      if (valueIndex !== -1) {
        uniqueUpsellProduct.splice(valueIndex, 1);
        i.remove();
      }
    }
  });
}